import { useTranslation } from "react-i18next";

const utilities = [
  { icon: "ri-shield-keyhole-line", titleKey: "token1_title", descKey: "token1_desc" },
  { icon: "ri-government-line", titleKey: "token2_title", descKey: "token2_desc" },
  { icon: "ri-funds-box-line", titleKey: "token3_title", descKey: "token3_desc" },
  { icon: "ri-exchange-2-line", titleKey: "token4_title", descKey: "token4_desc" },
];

export default function TokenSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-32 bg-[#070b14]">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 30% 50%, rgba(255,140,0,0.3) 0%, transparent 50%), radial-gradient(circle at 70% 50%, rgba(255,80,0,0.2) 0%, transparent 40%)" }} />
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
            <span className="text-amber-400 text-[10px] md:text-xs tracking-[0.3em] uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("token_badge")}</span>
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-3 md:mb-4" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("token_title")}</h2>
          <p className="text-white/40 text-xs md:text-sm max-w-xl mx-auto">{t("token_subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {utilities.map((u, i) => (
            <div key={i} className="group p-5 md:p-8 border border-white/10 rounded-lg bg-white/[0.02] hover:border-amber-400/30 hover:bg-amber-400/[0.03] transition-all duration-300">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-amber-400/10 border border-amber-400/20 flex-shrink-0 group-hover:bg-amber-400/20 transition-colors">
                  <i className={`${u.icon} text-amber-400 text-lg md:text-xl`} />
                </div>
                <div>
                  <h3 className="text-white font-bold text-xs md:text-sm mb-1.5 md:mb-2" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t(u.titleKey)}</h3>
                  <p className="text-white/40 text-xs md:text-sm leading-relaxed">{t(u.descKey)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 p-5 md:p-8 border border-amber-400/20 rounded-lg bg-amber-400/[0.03] text-center">
          <div className="inline-flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
            <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-amber-400/20 border border-amber-400/40">
              <i className="ri-coin-line text-amber-400 text-lg md:text-xl" />
            </div>
            <span className="text-amber-400 text-lg md:text-xl font-black tracking-widest" style={{ fontFamily: "'Orbitron', sans-serif" }}>$ARTM</span>
          </div>
          <p className="text-white/40 text-xs md:text-sm max-w-lg mx-auto" dangerouslySetInnerHTML={{ __html: t("token_supply") }} />
        </div>
      </div>
    </section>
  );
}
